import { createSlice, createSelector } from '@reduxjs/toolkit'
import { setWith } from 'lodash'

export const initialState = {
  // will look like:
  // 'some-ui-scope': { 'filters': { 'some-filter-name': 'some-value' } }
}

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setScopedFilter: (state, action) => {
      const { uiScope, filterName, value } = action.payload
      if (!uiScope || !filterName) {
        console.error('uiScope and filterName are required to set a filter')
        return
      }
      setWith(state, [uiScope, 'filters', filterName], value, Object)
    },
  },
})

// Selector to get filters for a specific scope
export const selectFiltersForScope = createSelector(
  [state => state.filters, (state, uiScope) => uiScope],
  (filtersState, uiScope) => {
    // Return filters for the given scope or an empty object if not available
    return filtersState[uiScope]?.filters || {}
  }
)

// Export actions and reducer
export const { setScopedFilter } = filtersSlice.actions
export default filtersSlice.reducer
